import { render, staticRenderFns } from "./linkMagaC.vue?vue&type=template&id=d7677e86&"
import script from "./linkMagaC.vue?vue&type=script&lang=js&"
export * from "./linkMagaC.vue?vue&type=script&lang=js&"
import style0 from "./linkMagaC.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports